// extracted by mini-css-extract-plugin
export var audioPlayer = "_t6-0";